export default __webpack_public_path__ + "static/feature-3-a25099166d17368f842f0fd5a8f977be.png";